<template>
    <client-page>
        <sub-visual-full bg="/images/sub/visual/sv1-2.jpg" scroll="false">
            <div class="text-ani-wrap mb-30 mb-lg-54">
                <div class="text-ani mb-14 mb-lg-28">
                    <h5 class="tit-txt line-height-1">세일즈웍스 그룹 아시아 </h5>
                </div>
                <div class="text-ani mb-8 mb-lg-20">
                    <h2 class="font-weight-bold font-size-40 font-size-md-54 font-size-lg-80 line-height-1">제임스 그리브즈</h2>
                </div>
                <div class="text-ani">
                    <p class="page-text--sm color-grey-d line-height-1">Executive Chairman</p>
                </div>
            </div>
            <p class="tit-txt color-grey-d">
                세일즈웍스는 업계 선두 주자로서 수많은 캠페이너와 성과를 배출해온 기업입니다. <br>
                가능성과 잠재력을 중시하는 자세로 교육과 트레이닝을 통해 인재를 양성해왔습니다. <br>
                안주하기보다는 도전하며, 성장에 집중하는 기업이 되기 위해 노력하고 있습니다.
            </p>
        </sub-visual-full>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisualFull from "@/components/client/sub/sub-visual-full.vue";
export default {
    components: {
        ClientPage,
        SubVisualFull,
    },
};
</script>

